"use client";
import { motion } from "framer-motion";
import { Building2, Users, Award, Truck } from "lucide-react";

const stats = [
  { icon: Users, number: "2,500+", label: "Customers Connected" },
  { icon: Building2, number: "5,000+", label: "Projects Completed" },
  { icon: Award, number: "350+", label: "Verified Applicators" },
  { icon: Truck, number: "48hr", label: "Fast Shipping" },
];

export function AboutStats() {
  return (
    <section
      id="about-stats"
      className="py-24 bg-card text-card-foreground dark:bg-stone-900 dark:text-foreground transition-colors"
      data-header-scheme="dark"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="text-center"
            >
              <stat.icon className="h-8 w-8 mx-auto mb-4 text-muted-foreground" />
              <div className="text-3xl md:text-4xl font-bold mb-2">
                {stat.number}
              </div>
              <div className="text-muted-foreground">{stat.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
